import { Component, ViewEncapsulation } from '@angular/core';
import { Grant } from '../../models/certs/grants.model';
import { CommunicationService } from '../../shared/services/communication.service';

import { ApiService } from '../../shared/services/api.service';
import { ListBase } from '../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-grant-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html',
  encapsulation: ViewEncapsulation.None
})
export class GrantListComponent extends ListBase<Grant> {

  public url = 'subsidies';
  public routePrefix = 'grants';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }

}
